"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class TranslateButtons extends _react.default.Component {
  render() {
    const {
      onSubmitTranslation
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-3 mb-3"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-secondary mr-4"
    }, "Auto Translate Selected"), /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-secondary mr-4"
    }, "Auto Translate All"), /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary",
      onClick: onSubmitTranslation
    }, "Save"));
  }
}
var _default = exports.default = TranslateButtons;
module.exports = exports.default;